import { LoadableLazy } from '@confluence/loadable';

export const LazyAutomationDiscoveryHoverPageTitleMessage = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutomationDiscoveryHoverPageTitleMessage" */ '../src/AutomationDiscoveryHoverPageTitleMessage.tsx'
			)
		).AutomationDiscoveryHoverPageTitleMessage,
});
